import React from 'react'
import Pin from 'components/icons/pcln-pin.svg'
import styled from '@emotion/styled'
import Button from './Button'

const TransparentButton = styled(Button)`
  padding: 0;
  background-color: transparent;
  color: inherit;

  &:hover {
    background-color: 'transparent';
  }

  & > div {
    display: flex;
  }
`

const PinButton = ({ color, size, title = '닫기', ...props }) => (
  <TransparentButton {...props}>
    <Pin color={color} size={size} title={title} />
  </TransparentButton>
)

export default PinButton
